import { Injectable } from '@angular/core'
import { CanLoad } from '@angular/router'

import { AuthorizerService } from '@vcomply/authorizer'
import { CacheService } from '@vcomply/cache'

import { environment } from 'src/environments/environment'
import { UtilityService } from '../services/utility.service'

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanLoad {
  constructor(private authorizer: AuthorizerService, private cacheService: CacheService, private utilityService: UtilityService) {}

  canLoad(): boolean {
    if (this.isValidToken() && !window.location.href.includes('?email_id=') && !window.location.href.includes('integration=outlook')) {
      this.routeToDashboard()
      return false
    }

    this.clearCache()
    return true
  }

  private isValidToken() {
    return this.authorizer.isValidToken()
  }

  private routeToDashboard() {
    this.utilityService.redirectToURL()
  }

  private clearCache() {
    this.cacheService.clearCache()
  }
}
